(function () {
  function initReadMore(root = document) {
    root.querySelectorAll('[data-collection-read-more]').forEach((trigger) => {
      if (trigger.dataset.bound === 'true') return;
      trigger.dataset.bound = 'true';

      const dialogId = trigger.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (!dialog || typeof dialog.showModal !== 'function') return;

      const closeButtons = dialog.querySelectorAll('[data-collection-read-close]');

      trigger.addEventListener('click', () => {
        if (dialog.open) return;
        dialog.showModal();
        document.body.classList.add('vt-collection-dialog-open');
      });

      closeButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          dialog.close();
          document.body.classList.remove('vt-collection-dialog-open');
        });
      });

      dialog.addEventListener('click', (event) => {
        const panel = dialog.querySelector('.vt-collection-hero__dialog-panel');
        if (panel && !panel.contains(event.target)) {
          dialog.close();
          document.body.classList.remove('vt-collection-dialog-open');
        }
      });

      dialog.addEventListener('close', () => {
        document.body.classList.remove('vt-collection-dialog-open');
      });

      dialog.addEventListener('cancel', () => {
        document.body.classList.remove('vt-collection-dialog-open');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReadMore(), { once: true });
  } else {
    initReadMore();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initReadMore(event.target);
  });
})();
